module.exports = __webpack_public_path__ + "static/88d7ce75709a840c565b6630a4f9e818feaec55cd58a5ecf963266ae208745c8-7da1497d074940ae3581d6e8632873cf.png";